import React from "react";
import CRUDManager from "../../../../shared/components/crud/CRUDManager";
import { vaccineConfig } from "../config/vaccineConfig";

export default function Vaccines() {
  return <CRUDManager config={vaccineConfig} />;
}
